import { render, staticRenderFns } from "./idiomas.vue?vue&type=template&id=01fbcac6&scoped=true&"
import script from "./idiomas.vue?vue&type=script&lang=js&"
export * from "./idiomas.vue?vue&type=script&lang=js&"
import style0 from "./idiomas.vue?vue&type=style&index=0&id=01fbcac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fbcac6",
  null
  
)

export default component.exports